//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_LOGIN = "/user/login"
export const VALIDATE_ACCESS = "/device/validateAccess"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//CUSTOMER
export const CUSTOMER = "/customer"
export const BATCH_REQUEST = "/batchRequest"

//PRODUCT
export const PRODUCT = "/product"

//OFFICE
export const OFFICES = "/office"

export const BILLS = "/bill"

export const BILL_CONFIGS = "/billConfig"

export const CATEGORY = "/category"
export const SIZE = "/size"
export const PRODUCT_SIZE = "/productSize"
export const PRODUCT_IMAGES = "/changeProductImage"
export const FIELD_OPTIONS = "/fieldOption"

//LOCATIONS
export const STATES = "/state"
export const MUNICIPALITIES = "/municipality"
export const DELIVERY_LOCALITY = "/deliveryLocality"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//TEMPLATES
export const TEMPLATES = "/template"

//TEMPLATES CATALOG
export const TEMPLATES_CATALOG = "/templateCatalog"

//WALLETS
export const WALLETS = "/movement"

//ITEMS
export const ITEMS = "/items"

//PAYMENTS
export const PAYMENTS = "/payment"

//ORDERS
export const ORDERS = "/order"
export const ORDERS_CHARGE_ON_DELIVERY = "/order/onlyBy/chargeOnDelivery"
export const DELIVERY_METHODS = "/deliveryMethod"
export const ORDERS_FOR_CONCILIATE = "/order/filterby/conciliations"
export const ORDER_CONFIRM_RECEIVED = "/order/confirm/received"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"

//DASHBOARD STATS
export const STATS_DASHBOARD = "/stats"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"

//TASKS
export const GET_TASKS = "/tasks"

//SECURITY
export const SECURITY_PERMISSIONS = "/securityPermission"
export const SECURITY_ROLES = "/securityRol"
export const SECURITY_PERMISSIONS_ROLES = "/sec/relate"
export const SECURITY_AUTHORIZATIONS = "/device"

//CONTACTS
export const USER = "/user"
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"

export const COMMENT = "/comment"

export const VCARD = "/vcard"
